import React from "react";
import { AlertCircle, ArrowRightCircle, CheckCircle2, FileQuestion } from "lucide-react";
import { fmtMoney } from "../../lib/appUtils";

export const CATEGORY_TONE = {
  design: "bg-indigo-50 text-indigo-700 border-indigo-200",
  construction: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const SERVICE_LABEL = {
  design_build: ["设计施工一站式", "Design-Build"],
  permit_only: ["Permit 办理", "Permit Only"],
  design_only: ["仅建筑设计", "Design Only"],
};

export function CategoryBadge({ row, zh, tid }) {
  return (
    <span data-testid={tid} data-category={row.category} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${CATEGORY_TONE[row.category] || ""}`}>
      {zh ? row.categoryZh : row.categoryEn}
      {row.category === "construction" && row.phaseName && row.phaseName !== "design" && <span className="ml-1 opacity-70">· {row.phaseName}</span>}
    </span>
  );
}

/* 收款状态：仅「已开票未收款」红色闪烁「立刻收款」；下一笔未触发收款绿色「下一步收款」；收齐 / 无合同为灰。 */
export function DueBadge({ fin, zh, tid, compact }) {
  if (fin.dueNow > 0) {
    return (
      <span data-testid={tid} data-state="due-now" className="dv3-blink inline-flex items-center gap-1 px-2 py-0.5 rounded-md border text-[11px] font-bold text-red-700 whitespace-nowrap">
        <AlertCircle className="h-3.5 w-3.5" />{zh ? "立刻收款" : "Collect now"} {fmtMoney(fin.dueNow)}
        {fin.overdueTotal > 0 && !compact && <span className="font-normal">· {zh ? "逾期" : "overdue"} {fmtMoney(fin.overdueTotal)}</span>}
      </span>
    );
  }
  if (fin.nextPayment) {
    return (
      <span data-testid={tid} data-state="next" className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md border border-emerald-200 bg-emerald-50 text-emerald-700 text-[11px] font-semibold whitespace-nowrap">
        <ArrowRightCircle className="h-3.5 w-3.5" />{zh ? "下一步收款" : "Next payment"} {fmtMoney(fin.nextPayment.amount)}
        {!compact && <span className="font-normal opacity-80">· {(zh ? fin.nextPayment.zh : fin.nextPayment.en) || fin.nextPayment.key}</span>}
      </span>
    );
  }
  if (fin.fullyPaid) {
    return <span data-testid={tid} data-state="paid" className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md border border-slate-200 bg-slate-50 text-slate-600 text-[11px] whitespace-nowrap"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />{zh ? "已全部收齐" : "Paid in full"}</span>;
  }
  return <span data-testid={tid} data-state="no-contract" className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md border border-dashed border-slate-200 text-slate-400 text-[11px] whitespace-nowrap"><FileQuestion className="h-3.5 w-3.5" />{zh ? "尚无合同付款表" : "No contract schedule"}</span>;
}
